<template>
  <div id="video-vue">
    <video class="video" ref="video" controls muted></video>
  </div>
</template>

<script>
let Hls = require('hls.js');
export default {
  name: "videoVue",
  props: ['path'],
  data() {
    return {
      hls: '',
    }
  },
  methods: {
    videoPause() {
      if (this.hls) {
        this.$refs.video.pause();
        this.hls.destroy();
        this.hls = null;
      }
    },
    play() {
      if (Hls.isSupported()) {
        this.hls = new Hls();
        this.hls.loadSource(this.path);
        this.hls.attachMedia(this.$refs.video);
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          this.$refs.video.play();
        });
        this.hls.on(Hls.Events.ERROR, (event, data) => {
          // 监听出错事件
        });
      }
    }
  },
  mounted() {
    this.play()
  },
  beforeDestroy() {
    this.videoPause();
  }
}
</script>

<style scoped>
#video-vue {
  width: 48%;
  height: 48%;
  margin: 1%;
  display: flex;
  flex-direction: column;
  background-size: 100% 100%;
}

.video {
  width: 100%;
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/cctv/videoVue.vue